const axios = require('axios')
require('dotenv').config()

export const registerMemberMailchimp = async (data) => {
  const { REACT_APP_SOCKET_URL } = process.env
  const res = await axios.post(`${REACT_APP_SOCKET_URL}mailchimp`, data)
     return res
}
